<template lang="pug">
div

  section
    .grid.is-small.is-middle
      .column.is-desktop-7
        AppTitle.u-mb-sm(:title="$t('mantra')")


  section
    .grid.is-desktop-6.base-grid
      .column
        AppCard( :img="[{ srcset: '{CDN_URL}/base/1@2x.webp 2x, {CDN_URL}/base/1.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/base/1@2x.png 2x, {CDN_URL}/base/1.png 1x', type: 'image/png' }]" ratio="2:1" :title="$t('introduction')" :excerpt="$t('introductionDesc')" url="/brand/system/introduction")
        AppCard( :img="[{ srcset: '{CDN_URL}/base/4@2x.webp 2x, {CDN_URL}/base/4.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/base/4@2x.png 2x, {CDN_URL}/base/4.png 1x', type: 'image/png' }]" ratio="1:1" :title="$t('colors')" :excerpt="$t('colorsDesc')" url="/brand/system/guidelines/colors")
        AppCard( :img="[{ srcset: '{CDN_URL}/base/5@2x.webp 2x, {CDN_URL}/base/5.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/base/5@2x.png 2x, {CDN_URL}/base/5.png 1x', type: 'image/png' }]" ratio="2:1" :title="$t('systemIcons')" :excerpt="$t('systemIconsDesc')" url="/brand/system/visuals/system-icons")

      .column
        AppCard( :img="[{ srcset: '{CDN_URL}/base/2@2x.webp 2x, {CDN_URL}/base/2.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/base/2@2x.png 2x, {CDN_URL}/base/2.png 1x', type: 'image/png' }]" ratio="1:1" :title="$t('components')" :excerpt="$t('componentsDesc')" url="/brand/system/components/grid")
        AppCard( :img="[{ srcset: '{CDN_URL}/base/3@2x.webp 2x, {CDN_URL}/base/3.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/base/3@2x.png 2x, {CDN_URL}/base/3.png 1x', type: 'image/png' }]" ratio="2:1" :title="$t('visuals')" :excerpt="$t('visualsDesc')" url="/brand/system/visuals/graphics")
        AppCard( :img="[{ srcset: '{CDN_URL}/base/6@2x.webp 2x, {CDN_URL}/base/6.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/base/6@2x.png 2x, {CDN_URL}/base/6.png 1x', type: 'image/png' }]" ratio="2:1" :title="$t('typography')" :excerpt="$t('typographyDesc')" url="/brand/system/guidelines/typography")



  section.u-mt-md
    AppTitle.u-mb-sm(:title="$t('moreResources')" tag="h2")
    .grid.is-small.is-middle
      .column.is-desktop-6
        AppCard.is-large( :img="[{ srcset: '{CDN_URL}/labs@2x.webp 2x, {CDN_URL}/labs.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/labs@2x.png 2x, {CDN_URL}/labs.png 1x', type: 'image/png' }]" :excerpt="$t('labsDesc')" ratio="2:1" :title="$t('labs')" url="/labs")
      .column.is-desktop-1
      .column.is-desktop-4
        AppCard.is-large( :img="[{ srcset: '{CDN_URL}/atlas@2x.webp 2x, {CDN_URL}/atlas.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/atlas@2x.png 2x, {CDN_URL}/atlas.png 1x', type: 'image/png' }]" :excerpt="$t('atlasDesc')" ratio="1:1" :title="$t('atlas')" url="/tools/atlas")
      .column.is-desktop-1

  section.u-mt-md
    .grid.is-middle
      .column.is-desktop-5
        AppTitle.u-mb-sm(:title="$t('corePrinciples')" tag="h2")
      .column.is-desktop-1
      .column.is-desktop-5
        p.u-text-ms {{$t('corePrinciples1')}}
        .u-divider.is-sm.u-mh-xs
        p.u-text-ms {{$t('corePrinciples2')}}
        .u-divider.is-sm.u-mh-xs
        p.u-text-ms {{$t('corePrinciples3')}}

  section.u-mt-md
    .grid.is-small.is-middle
      .column.is-desktop-6
        AppCard.is-large( :img="[{ srcset: '{CDN_URL}/default@2x.webp 2x, {CDN_URL}/default.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/default@2x.jpg 2x, {CDN_URL}/default.jpg 1x', type: 'image/jpg' }]" :excerpt="$t('cultureDesc')" ratio="2:1" :title="$t('culture')" url="/culture")
      .column.is-desktop-1
      .column.is-desktop-4
        AppCard.is-large( :img="[{ srcset: '{CDN_URL}/default@2x.webp 2x, {CDN_URL}/default.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/default@2x.jpg 2x, {CDN_URL}/default.jpg 1x', type: 'image/jpg' }]" :excerpt="$t('brandDesc')" ratio="1:1" :title="$t('brand')" url="/brand")
      .column.is-desktop-1

  .u-mb-md


</template>

<style lang="stylus">
.base-grid
  margin-left: -2px
  margin-right: -2px

  >.column
    padding-left: 2px
    padding-right: 2px

  .card
    position: relative
    margin-bottom: 4px

    &-body
      position: absolute
      bottom: 0
      left: 0
      right: 0
      color: $clWhite
      padding: unitRes(20, 80)

    &-excerpt
      max-width: 460px

    &-title
      a:hover
        color: $clWhite
</style>

<script>
import { generateSeoMeta } from '~/utils/seo';

export default {
  meta: {
    theme: 'base-home '
  },
  scrollToTop: true,

  head: generateSeoMeta(
    {
      title: 'title',
      description: 'description',
      image: 'shareImage'
    },
    { i18n: true }
  )
};
</script>

<i18n>
{
  "en": {
    "title":"Base design system",
    "description":"Base is Baianat master design system created to ensure a unified experience and feeling across all our official platforms.",
    "shareImage":"/share{CDN_URL}/base.png",
    "mantra":"Bold. flexible. |innovative.",
    "introduction":"Introduction",
    "introductionDesc":"Get started with Base design system.",
    "colors":"Colors",
    "colorsDesc":"Unique color palettes to suit every taste and need.",
    "systemIcons":"System Icons",
    "systemIconsDesc":"Express your huge ideas with custom tiny pixels.",
    "components":"Components",
    "componentsDesc":"Customize the design then Copy the code. No need for writing.",
    "visuals":"Visuals",
    "visualsDesc":"Express your vivid ideas with bold and colorful identity.",
    "typography":"Typography",
    "typographyDesc":"Write beautifully with text that matches your identity.",
    "moreResources":"Access more |resources.",
    "labs":"Labs",
    "labsDesc":"Access more resources, articles and helpful materials in fields of technology, design, code, and business.",
    "atlas":"Atlas",
    "atlasDesc":"Explore projects and tools made by Baianaters for the world.",
    "culture":"Culture",
    "cultureDesc":"Get to know more about the culture behind Base design team and read the inside stories.",
    "brand":"Brand",
    "brandDesc":"Using our design system to create a functional and abstarted brand for Baianat.",
    "corePrinciples":"Base essence and core |principles.",
    "corePrinciples1":"Abstracted as we brought everything back to its original shape for the sake of minimalism.",
    "corePrinciples2":"Functionality over aesthetics as we chose the easiest way not the most beautiful one.",
    "corePrinciples3":"Achieving accessibility so everyone can enjoy the same experience while interacting with base."
  },
  "ar": {
    "title":"نظام تصميم بيانات",
    "description":"تم إنشاء نظام التصميم الخاص ببيانات لضمان تصميم تجربة موحدة عبر جميع المنصات الرسمية الخاصة بنا.",
    "shareImage":"/share{CDN_URL}/base.png",
    "mantra":"جريء. مرن. |مبتكر. ",
    "introduction":"المقدمة",
    "introductionDesc":"ابدأ الآن مع نظام تصميم بيانات.",
    "colors":"الألوان",
    "colorsDesc":"لوحات ألوان فريدة تُناسب كل الأذواق والاحتياجات.",
    "systemIcons":"الأيقونات",
    "systemIconsDesc":"عبر عن أفكارك الهائلة باستخدام وحدات البسكل الصغيرة المخصصة.",
    "components":"المكونات",
    "componentsDesc":"لن تحتاج إلى الكتابة بعد الآن. خصص التصميم ثم انسخ الكود.",
    "visuals":"المرئيات",
    "visualsDesc":"عبر عن أفكارك واجعلها حية من خلال هوية جريئة وملونة.",
    "typography":"التايبوغرافي",
    "typographyDesc":"اختار النص الذي يتطابق مع روح هويتك.",
    "moreResources":"تعرف على  كل ما |يتعلق بنظام التصميم.",
    "labs":"المختبرات",
    "labsDesc":"الآن يمكنك الوصول إلى المزيد من الأدوات، والمقالات و الموارد المفيدة في مجالات التكنولوجيا والتصميم والبرمجة و الأعمال التجارية. ",
    "atlas":"أطلس",
    "atlasDesc":"ابدأ في بناء قاعدة معرفتك من خلال أطلس الذي يضُم المصطلحات والكلمات والاختصارات الرئيسية التي تحتاج إليها في مجالك.",
    "culture":"الثقافة",
    "cultureDesc":"تعرف أكثر على الثقافة التي تدعم فريق نظام التصميم وأقرأ المزيد حول قصصهم ولحظاتهم الداخلية.",
    "brand":"العلامة التجارية",
    "brandDesc":"اعتمدنا على نظام التصميم الخاص بنا من أجل إنشاء علامة بيانات التجارية التي تتمتع بالوظيفية والتجريد.",
    "corePrinciples":"جوهر نظام التصميم ومبادئه الرئيسية.",
    "corePrinciples1":"مُجرد؛ فقد تم رد كل شيء إلى شكله الأصلي لمزيد من البساطة.",
    "corePrinciples2":"الوظيفية تعلو على الشكل الجمالي لأننا اخترنا أسهل طريقة وليس أجملها.",
    "corePrinciples3":"نوفر إمكانية الوصول ليتمكن الجميع من الاستمتاع بنفس التجربة عند التفاعل مع نظام  التصميم الخاص بنا."

  }
}
</i18n>
